import { jwtDecode } from "jwt-decode";

export const DEFAULT_USER_ROLE = "2";
export type FIREBASE_TYPE = {
  tenant: string;
};

export type JWT_TYPE = {
  role: number;
  uuid: string;
  products: string[];
  email: string;
  name: string;
  firebase?: FIREBASE_TYPE;
};

export const FAKE_JWT: JWT_TYPE = {
  role: 2,
  uuid: "",
  products: [],
  email: "",
  name: "",
};
export function getJWTDecoded(token?: string): JWT_TYPE {
  const finalToken = token || window.localStorage.getItem("token");
  return finalToken ? (jwtDecode(finalToken) as JWT_TYPE) : FAKE_JWT;
}
